import React, { Component } from 'react';
import { object, bool, string, func, number, shape } from 'prop-types';
import ReportFavorite from './ReportFavorite';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as reportActionCreators from '../ReportActions';

class ReportFavoriteContainer extends Component {
  static propTypes = {
    id: string,
    isFavorite: bool,
    actions: object
  };
  constructor(props) {
    super(props);
    this.setReportFavorite = this.setReportFavorite.bind(this);
  }
  setReportFavorite(isFavorite) {
    this.props.actions.setReportFavorite(this.props.id, isFavorite);
  }
  render() {
    return (
      <ReportFavorite id={this.props.id} isFavorite={this.props.isFavorite} setFavorite={this.setReportFavorite} />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(reportActionCreators, dispatch)
});

export default connect(null, mapDispatchToProps)(ReportFavoriteContainer);
